import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';
import useIsAuthenticated from './hooks/auth/useIsAuthenticated';
import Index from './index';

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Index,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  errorBoundary(err, info, props) {
    return <div className="mt-16">Error</div>;
  },
  renderType: 'createRoot',
});

export const { bootstrap, mount, unmount } = lifecycles;
export { navbarSyncDataSubject$, SyncDataSubject } from './sharedSubjects';
export { useIsAuthenticated };
